import React from 'react';
import { IQuestionElementProps } from '../../interface';
import { RadioOptionInfo } from '../radioOptionInfo';

const RadioQuestion = (props: IQuestionElementProps) => {
    return <RadioOptionInfo {...props} multiple={false} />;
};
export { RadioQuestion };
